export const areaProvinceJSON = [
  {
    id: "hb",
    name: "华北",
    cNum: 5,
    check: 0,
    children: [
      { name: "北京", id: 2 },
      { name: "天津", id: 26, url: "https://tj.qianlima.com" },
      { name: "河北", id: 9 },
      { name: "山西", id: 22 },
      { name: "内蒙古", id: 18 },
    ],
  },
  {
    id: "hz",
    name: "华中",
    cNum: 4,
    check: 0,
    children: [
      { name: "河南", id: 10 },
      { name: "湖北", id: 12, url: "https://hbs.qianlima.com" },
      { name: "湖南", id: 13 },
      { name: "江西", id: 16, url: "https://jx.qianlima.com" },
    ],
  },
  {
    id: "hn",
    name: "华南",
    cNum: 3,
    check: 0,
    children: [
      { name: "广东", id: 5 },
      { name: "广西", id: 6 },
      { name: "海南", id: 8 },
    ],
  },
  {
    id: "db",
    name: "东北",
    cNum: 3,
    check: 0,
    children: [
      { name: "吉林", id: 14 },
      { name: "辽宁", id: 17, url: "https://ln.qianlima.com" },
      { name: "黑龙江", id: 11, url: "https://hlj.qianlima.com" },
    ],
  },
  {
    id: "xb",
    name: "西北",
    cNum: 5,
    check: 0,
    children: [
      { name: "陕西", id: 23, url: "https://sxs.qianlima.com" },
      { name: "甘肃", id: 4 },
      { name: "宁夏", id: 19 },
      { name: "青海", id: 20, url: "https://qh.qianlima.com" },
      { name: "新疆", id: 28 },
    ],
  },
  {
    id: "hd",
    name: "华东",
    cNum: 6,
    check: 0,
    children: [
      { name: "山东", id: 21, url: "https://sd.qianlima.com" },
      { name: "安徽", id: 1 },
      { name: "上海", id: 24, url: "https://sh.qianlima.com" },
      { name: "江苏", id: 15, url: "https://js.qianlima.com" },
      { name: "浙江", id: 30 },
      { name: "福建", id: 3 },
    ],
  },
  {
    id: "xn",
    name: "西南",
    cNum: 5,
    check: 0,
    children: [
      { name: "云南", id: 29 },
      { name: "贵州", id: 7 },
      { name: "四川", id: 25 },
      { name: "重庆", id: 31 },
      { name: "西藏", id: 27 },
    ],
  },
  {
    id: "gat",
    name: "港澳台",
    cNum: 3,
    check: 0,
    children: [
      { name: "香港", id: 3557 },
      { name: "澳门", id: 3558 },
      { name: "台湾", id: 3559 },
    ],
  },
];
